<template>
  <div
    class="custom-select-container"
  >
    <b-form-select
      v-model="fontWeightSizeSelected"
      data-test="font-weigh-select"
      :disabled="disabled"
      @change="handleChangedOption"
    >
      <option
        v-for="option in optionsList"
        :key="option.value"
        :value="option.value"
        :style="getFontWeightStyle(option.value)"
      >
        {{ option.text }}
      </option>
    </b-form-select>
  </div>
</template>
<script>

function initialData() {
  return {
    fontWeightSizeSelected: null,
  };
}

export default {
  name: 'BaseFontWeightSelect',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      default: 400,
    },
    fontFamily: {
      type: String,
      default: 'Roboto',
    },
  },
  data() {
    return initialData();
  },
  computed: {
    optionsList() {
      return [
        { text: 'Thin', value: 100 },
        { text: 'Normal', value: 400 },
        { text: 'Bold', value: 700 },
      ];
    },
  },
  methods: {
    getFontWeightStyle(fontWeightSize) {
      return {
        'font-weight': fontWeightSize,
        'font-family': this.fontFamily,
      };
    },
    handleChangedOption(option) {
      this.$emit('updateValue', option);
    },
  },
  created() {
    this.fontWeightSizeSelected = this.value;
  },
};
</script>
<style scoped lang="scss">
</style>
